<template>
<v-row>
    <v-col  cols="12" sm="12" md="12">
            <v-row>
                <v-col  cols="12" sm="12" md="12">
                    <botaoVoltar />
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <h2>DADOS DA SOLICITAÇÃO</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-row>
                        <v-col cols="12" sm="12" md="12"><span class="font-weight-bold">Orgão: </span>{{ this.descricaoOrigemProcura }}<span v-show="this.testTextHasValue(this.descricaoOrgao)"> / </span>{{ this.descricaoOrgao }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span class="font-weight-bold">Protocolo:</span>{{ idSolicitacao }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" md="6">
                            <span class="font-weight-bold">Data: </span>{{ dataHoraSolicitacao  | formatDate_BR() }}
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                            <span class="font-weight-bold">Situação: </span>{{ descricaoStatusSolicitacao }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" md="6">
                            <span class="font-weight-bold">Perfil da solicitação: </span>{{ descricaoTipoPerfilSolicitacao }}
                        </v-col>  
                        <v-col cols="6" sm="6" md="6">
                            <span class="font-weight-bold">Tipo: </span>{{ descricaoTipoSolicitacao }}
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span class="font-weight-bold">Motivo do {{ (tipoSolicitacao == 'R') ? "reordenamento" : "acolhimento" }}: </span>{{ (tipoSolicitacao == 'R') ? descricaoMotivoReordenamento : descricaoMotivoProcura }}
                        </v-col>
                    </v-row> 
                    <v-row v-show="tipoPerfilSolicitacao == 'G'">
                        <v-col cols="12" sm="12" md="12"><span class="font-weight-bold ">Aceita acolhimento separado? </span> <span :class="(acolhimentoSeparado == 'Sim')? 'green--text' : 'red--text'">{{ acolhimentoSeparado }}</span></v-col>  
                    </v-row> 
                    <v-row>
                        <v-col cols="6" sm="6" md="4">
                            <span class="font-weight-bold">Breve relato da solicitação: </span>
                        </v-col>
                        <v-col cols="6" sm="6" md="8">
                            {{ breveRelato }}
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col cols="12" sm="12" md="12">   
                            <v-divider></v-divider>   
                        </v-col> 
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h3>Responsável pela Solicitação</h3>
                        </v-col> 
                    </v-row>      
                    <v-row>
                        <v-col  cols="12" sm="12" md="6">
                            <span class="font-weight-bold">Nome: </span>{{ nomeResponsavelSolicitacao }}
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                            <span class="font-weight-bold">Telefone para comunicação: </span>{{ telefoneResponsavelSolicitacao | TelefoneFormatado }}
                        </v-col>
                    </v-row>      
                    <v-row>
                        <v-col cols="12" sm="12" md="6">
                            <span class="font-weight-bold">E-mail para comunicação 1: </span>{{ emailResponsavelSolicitacao }}
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <span class="font-weight-bold">E-mail para comunicação 2: </span>{{ emailResponsavelSolicitacaoSecundario }}
                        </v-col>

                    </v-row> 
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span class="font-weight-bold">Tipo de serviço para {{ (tipoSolicitacao == 'R') ? "reordenamento" : "acolhimento" }}: </span>{{ descricaoTipoServico }}
                        </v-col>                      
                    </v-row>
                </v-col>       
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>                
                    
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">
                    <h3>Solicitação Indeferida</h3>
                </v-col>
            </v-row>
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">
                    <span class="font-weight-bold">Motivo: </span>
                    <span>{{ motivoIndeferimento }}</span>
                </v-col>
            </v-row>
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">
                    <span class="font-weight-bold">Descrição: </span>
                    <span>{{ descricaoMotivoIndeferimento }}</span>
                </v-col>
            </v-row>  

            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>      
              
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <h3>Endereço de Referência do(s) Cidadão(s)</h3>
                </v-col>
            </v-row>                 
            <v-row>
                <v-col cols="12" sm="12" md="12">
                  <p><span class="font-weight-bold">CEP:</span> {{ enderecoSolicitacao.cep }}</p>
                  <p><span class="font-weight-bold">Logradouro: </span>{{ enderecoSolicitacao.siglaLogradouro }} {{ enderecoSolicitacao.nomeLogradouro }}, {{ enderecoSolicitacao.numeroLogradouro }}<span v-if="(enderecoSolicitacao.complemento != null && enderecoSolicitacao.complemento.length > 0)"> - Complemento: {{ enderecoSolicitacao.complemento }}</span><span v-if="(enderecoSolicitacao.pontoReferencia != null && enderecoSolicitacao.pontoReferencia.length > 0)"> - <span class="font-weight-bold">Referência: </span>{{ enderecoSolicitacao.pontoReferencia }}</span></p>
                  <p><span class="font-weight-bold">Distrito: </span>{{ enderecoSolicitacao.DescricaoDistrito }} - <span class="font-weight-bold">Subprefeitura: </span>{{ enderecoSolicitacao.DescricaoSubprefeitura }}</p>
                </v-col>
            </v-row>     

            <v-row>
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>   

            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h4>Cidadão(s)</h4>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Nome Social</th>
                                            <th>Nome da mãe</th>
                                            <th>Data de Nascimento</th>
                                            <th>Genêro</th>
                                            <th>Identidade de Gênero</th>
                                            <th>Encaminhamento</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="item in listCitizen"
                                            :key="item.codigoCidadaoSolicitacao"
                                        >
                                        <td width="40%">{{ item.nome }}</td>
                                        <td width="20%">{{ item.nomeSocial }}</td>
                                        <td width="30%">{{ item.nomeMae }}</td>
                                        <td>{{ item.dataNascimento | formatDate_BR() }}</td>
                                        <td>{{ item.descricaoTipoSexo }}</td>
                                        <td>{{ item.descricaoIdentidadeSexual }}</td>
                                        <td class="text-align:center">{{ (item.descricaoStatusEncaminhamento) ? item.descricaoStatusEncaminhamento : 'Não processado' }}</td>
                                        <td>
                                            <v-icon v-if="testTextHasValuePending(item.descricaoStatusEncaminhamento)"
                                                :title="titleEncaminhamento(item.descricaoStatusEncaminhamento)"
                                                @click="showModalForwardingCancel(idSolicitacao,item.codigoSrvicoHospedagemReservaVaga, item.codigoCidadaoSolicitacao)">
                                                mdi-file-cancel-outline
                                            </v-icon>
                                            <v-icon title="Visualizar"
                                                @click="showModalCitizenDetail(item.codigoCidadaoSolicitacao)">
                                                mdi-eye
                                            </v-icon>
                                            <v-icon title="" v-if="1 === 3" @click="deleteCitizen(item.codigoCidadaoSolicitacao)">
                                                mdi-delete
                                            </v-icon>
                                        </td>                                        
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <modalShowCitizen ref="mdShowCitizen" :dialog.sync="showModalCitizen" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>   
            
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <h3>Arquivos da Solicitação</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <span>
                        Não envie documentos pessoais e/ou fotos do cidadão. Para saber quais documentos enviar, consulte as fichas técnicas de cada tipologia disponíveis no site <a href='https://www.prefeitura.sp.gov.br/cidade/secretarias/assistencia_social/central_de_vagas/' target="blank">Central de Vagas</a>
                    </span>
                </v-col>                
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <SelectFiles ref="selectFiles" :requestID="this.$route.params.id" :status="this.codigoStatusSolicitacao" />
                </v-col>
            </v-row>                 
    </v-col>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />
        <modalCancelForwarding ref="mdCancelForwarding" :dialog.sync="showModalForwardingCitizenCancel" />
</v-row>
</template>
<script>
import { mapGetters } from "vuex";
import snackbarMixin from "@/mixins/snackbar.mixin";
import goBack from '../../components/GoBack.vue';
import requestService from '../../services/request.service';
import DetailCitizen from '../citizen/CitizenDetail.vue';
import loginService from '../../services/security/login.service';
import SelectFiles from '@/components/SelectFiles.vue';
import CancelForwarding from '../citizen/CancelForwardingCitizen.vue';

export default {
    mixins: [snackbarMixin],
    components:{
        'botaoVoltar': goBack,
        'modalShowCitizen': DetailCitizen,
        'modalCancelForwarding': CancelForwarding,
        SelectFiles 
    },    
    data(){
        return{
            headers: [
                { text: "Nome", value: "nome" },
                { text: "Nome Social", value: "nomeSocial" },
                { text: "Nome da mãe", value: "nomeMae" },
                { text: "Data de Nascimento", value: "dataNascimento" },
            ],
            loading: false,
            nodata: true,
            error: "",
            idSolicitacao:'',
            descricaoMotivoProcura:'',
            descricaoMotivoReordenamento: '',
            descricaoStatusSolicitacao:'',
            codigoStatusSolicitacao: '',
            descricaoTipoPerfilSolicitacao:'',
            dataHoraSolicitacao: '',
            nomeResponsavelSolicitacao: '',
            emailResponsavelSolicitacao: '',
            emailResponsavelSolicitacaoSecundario: '',
            telefoneResponsavelSolicitacao: '',
            breveRelato: '',
            enderecoSolicitacao: '',
            descricaoTipoSolicitacao: '',
            listCitizen: [],
            showModalCitizen: false,
            codigoTipoServico: '',
            descricaoTipoServico: '',
            tipoSolicitacao: '',
            acolhimentoSeparado:'',
            tipoPerfilSolicitacao:'',
            motivoIndeferimento:'',
            descricaoMotivoIndeferimento:'',
            showButtonCancel:false,
            showModalForwardingCitizenCancel:false,
            descricaoOrigemProcura:'',
            descricaoOrgao:'',
        }
    },
    computed:{
        ...mapGetters("request", ["listRequest"])
    },
    watch: {
        list: function () {
            if (this.listRequests <= 0) {
                this.nodata = true;
            } else {
                this.nodata = false;
            }
        },
        options: {
            handler() {
                this.search();
            },
            deep: true,
        },
        showModalCitizen(value) {
            if(value){
                this.$refs.mdShowCitizen.clear();
            }
        },
        showModalForwardingCitizenCancel(value){
            if(value){
                this.$refs.mdCancelForwarding.clear();
            }
        }
    },
    mounted() {
        if(this.$route.params.id){
            requestService.getSolicitacaoById(this.$route.params.id)
            .then(result =>{
                if(result.status == 200 && result.data){
                    let r = result.data;
                    if(r){
                        this.idSolicitacao = r.idSolicitacao.toString().padStart(8,'0');
                        this.descricaoMotivoProcura = r.descricaoMotivoProcura;
                        this.descricaoMotivoReordenamento = (r.descricaoMotivoReordenamento != null && r.descricaoMotivoReordenamento != undefined) ? r.descricaoMotivoReordenamento : "";
                        this.descricaoStatusSolicitacao = r.descricaoStatusSolicitacao;
                        this.codigoStatusSolicitacao = r.status;
                        this.descricaoTipoPerfilSolicitacao = r.descricaoTipoPerfilSolicitacao;
                        this.dataHoraSolicitacao = r.dataHoraSolicitacao;
                        this.nomeResponsavelSolicitacao = r.nomeResponsavelSolicitacao;
                        this.emailResponsavelSolicitacao = r.emailResponsavelSolicitacao;
                        this.emailResponsavelSolicitacaoSecundario = r.emailResponsavelSolicitacaoSecundario;
                        this.telefoneResponsavelSolicitacao = r.telefoneResponsavelSolicitacao;
                        this.listCitizen = r.cidadaos;
                        this.breveRelato = r.breveRelato;
                        this.enderecoSolicitacao = r.enderecoSolicitacao;
                        this.descricaoTipoSolicitacao = r.descricaoTipoSolicitacao;
                        this.codigoTipoServico = r.codigoTipoServico;
                        this.descricaoTipoServico = r.descricaoTipoServico;
                        this.tipoSolicitacao = r.tipoSolicitacao;
                        this.acolhimentoSeparado = r.acolhimentoSeparado;
                        this.tipoPerfilSolicitacao = r.perfilSolicitacao;
                        this.motivoIndeferimento= r.motivoIndeferimento;
                        this.descricaoMotivoIndeferimento = r.descricaoMotivoIndeferimento;
                        this.descricaoOrigemProcura = r.descricaoOrigemProcura;
                        this.descricaoOrgao = r.descricaoOrgao;
                        this.$refs.selectFiles.loadFiles();
                    }
                } else {
                    this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                }
            }
            ).catch(error =>{
                this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                console.log(error);
            });
        }
    },
    filters: {
        TelefoneFormatado: function (value) {
            var formartMask = '';
            var telefone =  '';
            if (!value) return ''
            value = value.toString();
            formartMask = "(##) #####-####";
 

            if (formartMask != "")
             telefone = formatDefault(value,formartMask) ;
             else
             telefone = value;

            return  telefone ;
        }

    },
    methods:{
       testTextHasValuePending(value){
            return (value != undefined && value != null && value.length > 0 && value == 'Pendente');
       },
       testTextHasValue(value){
           return (value != undefined && value != null && value.length > 0);
       },
       titleEncaminhamento(value){
           var title ='';
           if(value != null && value.length > 0 )
           {
                if(value == 'Pendente')
                    title = 'Excluir Encaminhamento';
                else
                    title = 'Visualizar Encaminhamento';
           }
           return title;
       },
       async search(){
            try {
                this.loading = true;
                let data = this.getFilters();
                await this.$store.dispatch("request/listRequest", data);
                this.nodata = false;

            } catch (error) {
                this.error = error;
                this.nodata = true;
            }finally{
                this.loading = false;
            }
        },
        showModalCitizenDetail(idCitizen){
            this.checkUserLogged();
            var citiz = this.listCitizen.filter(obj => { return obj.codigoCidadaoSolicitacao == idCitizen });
            this.$refs.mdShowCitizen.loadRequestCitizen(citiz[0], this.idSolicitacao);
            this.showModalCitizen=true;

        },
        deleteCitizen(idCitizen){
            requestService.deleteCidadaoById(idCitizen)
            .then(result =>{
                    if(result.status == "200"){
                    this.showSnackbar("Cidadão excluido");
                }
            }
            ).catch(error =>{
                this.showSnackbar("Não foi possível excluir o cidadão.", 'error');
                console.log(error);
            });
        },
       checkUserLogged(){
           var objLogin = this.$store.state.login;
           loginService.getOperator(objLogin.userLogin)
           .then(response => 
           { 
               console.log(response);
               return true; 
           }).catch(error => 
            { 
                if(error.toString().indexOf('code 401') != -1){
                    this.showSnackbar('Sessão expirada.', 'erro');
                    this.$router.push({ name: 'login' });
                }
            });
       },
        showModalForwardingCancel(idForm, idReserva, idCidadao){
            this.$refs.mdCancelForwarding.loadForwardingCitizen(idForm,idReserva,idCidadao, this.listCitizen);
            this.showModalForwardingCitizenCancel = true;
        }
        
    }
}


function formatDefault (value, mask) {
      
      let result = "";
      let count = 0;
      if (value) {
        
        let arrayValue = value.toString().split("");
        let arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    }
</script>
<style scoped>
tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
</style>